import { FC, useState, useCallback } from 'react';
import { useExamContext } from '@new/features/courses/contexts/ExamProvider';

import Modal from '@new/common/ui/Modal/Modal';
import { ResultStats } from './ResultStats';
import { FilterButtons } from './FilterButtons';
import { ExamQuestionsContainer } from './ExamQuestionsContainer';

export type ExamFilterType = 'all' | 'correct' | 'incorrect';

export const ExamResultModal: FC = () => {
  const { examMode, exitExam } = useExamContext();
  const [filter, setFilter] = useState<ExamFilterType>('all');
  const [activeQuestionId, setActiveQuestionId] = useState<number | null>(null);

  const isOpen = examMode.type === 'result';

  const handleQuestionSelect = useCallback((questionId: number) => {
    setActiveQuestionId(questionId);
  }, []);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={exitExam} title="Exam Result" className="w-sm md:w-md lg:w-3xl">
      <div className="flex h-full min-h-0 flex-col">
        <div className="flex min-h-0 flex-1 flex-col gap-6">
          <ResultStats />
          <div className="flex min-h-0 flex-1 flex-col gap-4 lg:gap-6">
            <FilterButtons activeFilter={filter} onFilterChange={setFilter} />
            <div className="min-h-0 flex-1">
              <ExamQuestionsContainer
                filter={filter}
                activeQuestionId={activeQuestionId}
                onQuestionSelect={handleQuestionSelect}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
